'use client';

import { create } from 'zustand';

export interface UsePreviewModeState {
    isPreviewMode: boolean;
}

export interface UsePreviewModeActions {
    setPreviewMode: () => void;
}

export const usePreviewModeStore = create<UsePreviewModeState & UsePreviewModeActions>(
    (set, get) => ({
        isPreviewMode: false,
        setPreviewMode: () => {
            const { isPreviewMode } = get();

            return set({ isPreviewMode: !isPreviewMode });
        },
    })
);
